import { Image } from "react-native";
import { getMultimedia } from "../../Functions/getRecurs";
import React from "react";

export default (premi) => {
  if (premi.esUnVideo) {
    return (
      <iframe
        src={premi.linkVideo}
        allow="fullscreen;geolocation;camera;gyroscope;accelerometer;magnetometer"
        style={{
          height: "100%",
          width: "100%",
          resizeMode: "contain",
          borderRadius: 5,
        }}
      />
    );
  }

  return (
    <Image
      style={{
        width: "100%",
        height: "100%",
        alignSelf: "center",
        resizeMode: "contain",
      }}
      source={{ uri: getMultimedia(premi, "Premi") }}
    />
  );
};
